import { Layer } from '@myua/icons/dist/linear16';
import { useSelector, useDispatch } from 'react-redux';
import { getSearchOptions } from '../selectors';
import * as searchActions from '../actions';
import { Checkbox, Popover, Button } from '@myua/kit';
import { SearchShape } from '../model';
import { useState, useEffect } from 'react';
import { ReactNode } from 'react';

const OPTIONS: { label: ReactNode; value: keyof SearchShape['options'] }[] = [
  { label: 'Search in layers', value: 'searchInLayers' },
  { label: 'Search in archives', value: 'searchInArchives' },
];

export const Options = ({ disabled }: { disabled?: boolean }) => {
  const dispatch = useDispatch();
  const searchOptions = useSelector(getSearchOptions);
  const [open, setOpen] = useState(false);

  const [values, setValues] = useState<string[]>([]);
  useEffect(() => {
    setValues(OPTIONS.map(({ value }) => value).filter((value) => searchOptions[value]));
  }, [searchOptions, open]);

  const disabledByAi = searchOptions.searchWithAi;
  const isDisabled = disabled || disabledByAi;
  const active = OPTIONS.some(({ value }) => searchOptions[value]);

  return (
    <Popover
      title="Options"
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      classNames={{ root: 'al-search-options-overlay' }}
      content={
        <div className="al-search-options">
          <Checkbox.Group
            className="al-search-options__items"
            options={OPTIONS}
            value={values}
            onChange={setValues}
          />
          <div className="al-search-options__buttons">
            <Button
              size="small"
              type="primary"
              onClick={() => {
                setOpen(false);
                const newSearchOptions = { ...searchOptions };
                OPTIONS.forEach(({ value }) => {
                  newSearchOptions[value] = values.includes(value);
                });
                dispatch(searchActions.optionsChanged({ options: newSearchOptions }));
              }}
            >
              Apply
            </Button>
            <Button size="small" onClick={() => setOpen(false)}>
              Close
            </Button>
          </div>
        </div>
      }
    >
      <span
        onClickCapture={(e) => {
          if (isDisabled) {
            e.stopPropagation();
          }
        }}
        title="Options"
        className={`al-search__icon ${
          isDisabled ? 'al-search__icon_disabled' : active ? 'al-search__icon_active' : ''
        }`}
      >
        <Layer />
      </span>
    </Popover>
  );
};
